import React from 'react';
import cn from 'classnames';
import {
  createStyles,
  TextField,
  TextFieldProps,
  withStyles,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core/styles';
import { ellipsisProps } from 'globals/utils';

export type FsDefaultInputProps = TextFieldProps & {
  fsVariant?: 'outlined';
};

const useStyles = makeStyles(({ palette, transitions, spacing }: Theme) =>
  createStyles({
    root: {
      '.FsOutlined &': {
        border: `1px solid ${palette.grey[200]}`,
        overflow: 'hidden',
        borderRadius: spacing(1),
        backgroundColor: palette.common.white,
        transition: transitions.create(['border-color']),
        '&:hover': {
          backgroundColor: palette.common.white,
          borderColor: palette.grey[300],
        },
        '&$focused': {
          backgroundColor: palette.common.white,
          borderColor: palette.primary.main,
        },
      },
    },
    focused: {},
  })
);

export default withStyles(({ spacing, palette }) =>
  createStyles({
    root: {
      '& .MuiInputBase-root': {
        background: palette.common.white,
        '& fieldset': {
          borderColor: palette.grey[200],
        },
        '&:hover fieldset': {
          borderColor: palette.grey[300],
        },
        '&.Mui-focused fieldset': {
          borderColor: palette.primary.main,
        },
      },
      '& [type=password]': {
        fontFamily: `'Arial', sans-serif`,
        color: palette.grey[200],
        letterSpacing: spacing(0.5),
        fontSize: 25,
        height: 19,
      },
      '& .MuiFilledInput-underline:before': {
        borderColor: palette.grey[200],
      },
      '&:hover .MuiFilledInput-underline:before': {
        borderColor: palette.grey[300],
      },
      '& .MuiOutlinedInput-adornedEnd': {
        paddingRight: spacing(1),
      },
      '& .MuiInputBase-adornedEnd': {
        paddingRight: spacing(1),
      },
      '& .MuiSelect-select': {
        background: palette.common.white,
      },
      '& .Mui-error, & .Mui-error:hover': {
        borderColor: palette.error.main,
      },
      '& .MuiFormLabel-root': {
        ...ellipsisProps,
        maxWidth: '83%',
      },
    },
  })
)(({ fsVariant, InputProps, ...otherProps }: FsDefaultInputProps) => {
  const classes = useStyles();
  const isFsVariant = fsVariant === 'outlined';
  return (
    <TextField
      autoComplete="off"
      {...otherProps}
      InputProps={{
        classes,
        ...InputProps,
        disableUnderline: isFsVariant ? true : undefined,
      }}
      className={cn({ FsOutlined: isFsVariant })}
      variant="filled"
    />
  );
});
